import script from "./LabelView.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelView.vue?vue&type=script&setup=true&lang=js"

import "./LabelView.vue?vue&type=style&index=0&id=28bc6692&lang=css"

const __exports__ = script;

export default __exports__